var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { COMMUNICATION_CHART_COLORS } from '@web/components/CommunicationNetworkGraph/graph/communicationChartConstants';
var LEGEND_VOLUME_BAR_WIDTH_PX = 14;
var LEGEND_VOLUME_BAR_GAP_PX = 2;
var LEGEND_VOLUME_BAR_HEIGHTS_PX = [1, 3, 6];
/** Width of the three-bar volume swatch; other legend lines match this. */
export var COMMUNICATION_CHART_LEGEND_SWATCH_WIDTH_PX = LEGEND_VOLUME_BAR_WIDTH_PX * LEGEND_VOLUME_BAR_HEIGHTS_PX.length +
    LEGEND_VOLUME_BAR_GAP_PX * (LEGEND_VOLUME_BAR_HEIGHTS_PX.length - 1);
var LEGEND_LINE_STROKE_PX = 3;
var LEGEND_SWATCH_TRACK_HEIGHT_PX = Math.max.apply(Math, LEGEND_VOLUME_BAR_HEIGHTS_PX);
export var CommunicationChartVolumeSwatch = function () { return (_jsx("div", __assign({ className: "flex shrink-0 items-center gap-0.5", "aria-hidden": true }, { children: LEGEND_VOLUME_BAR_HEIGHTS_PX.map(function (height) { return (_jsx("span", { className: "rounded-sm", style: {
            width: LEGEND_VOLUME_BAR_WIDTH_PX,
            height: height,
            backgroundColor: COMMUNICATION_CHART_COLORS.linkTrendUnchanged
        } }, height)); }) }))); };
export var CommunicationChartDirectionSwatch = function () { return (_jsxs("span", __assign({ className: "relative block shrink-0", style: {
        width: COMMUNICATION_CHART_LEGEND_SWATCH_WIDTH_PX,
        height: LEGEND_SWATCH_TRACK_HEIGHT_PX
    }, "aria-hidden": true }, { children: [_jsx("span", { className: "absolute left-[9px] right-[14px] top-1/2 block -translate-y-1/2", style: {
                height: LEGEND_LINE_STROKE_PX,
                backgroundColor: COMMUNICATION_CHART_COLORS.linkTrendUnchanged
            } }), _jsx("span", { className: "absolute left-0 top-1/2 block h-0 w-0 -translate-y-1/2 border-y-[4px] border-r-[9px] border-y-transparent", style: {
                borderRightColor: COMMUNICATION_CHART_COLORS.linkTrendUnchanged
            } }), _jsx("span", { className: "absolute right-0 top-1/2 block h-0 w-0 -translate-y-1/2 border-y-[6px] border-l-[14px] border-y-transparent", style: { borderLeftColor: COMMUNICATION_CHART_COLORS.linkTrendUnchanged } })] }))); };
export var CommunicationChartChatLineSwatch = function (_a) {
    var _b = _a.lineColor, lineColor = _b === void 0 ? COMMUNICATION_CHART_COLORS.linkTrendUp : _b;
    return (_jsxs("span", __assign({ className: "relative block shrink-0", style: {
            width: COMMUNICATION_CHART_LEGEND_SWATCH_WIDTH_PX,
            height: LEGEND_SWATCH_TRACK_HEIGHT_PX
        }, "aria-hidden": true }, { children: [_jsx("span", { className: "absolute left-[9px] right-[9px] top-1/2 block -translate-y-1/2", style: { height: LEGEND_LINE_STROKE_PX, backgroundColor: lineColor } }), _jsx("span", { className: "absolute left-0 top-1/2 block h-0 w-0 -translate-y-1/2 border-y-[6px] border-r-[9px] border-y-transparent", style: { borderRightColor: lineColor } }), _jsx("span", { className: "absolute right-0 top-1/2 block h-0 w-0 -translate-y-1/2 border-y-[6px] border-l-[9px] border-y-transparent", style: { borderLeftColor: lineColor } })] })));
};
export var CommunicationChartMeetLineSwatch = function (_a) {
    var _b = _a.lineColor, lineColor = _b === void 0 ? COMMUNICATION_CHART_COLORS.linkTrendUp : _b;
    return (_jsx("span", { className: "block shrink-0 rounded-sm", style: {
            width: COMMUNICATION_CHART_LEGEND_SWATCH_WIDTH_PX,
            height: LEGEND_LINE_STROKE_PX,
            backgroundColor: lineColor
        }, "aria-hidden": true }));
};
export var CommunicationChartTrendLineSwatch = function (_a) {
    var color = _a.color, _b = _a.dashed, dashed = _b === void 0 ? false : _b;
    return (_jsx("span", __assign({ className: "flex shrink-0 items-center", style: {
            width: COMMUNICATION_CHART_LEGEND_SWATCH_WIDTH_PX,
            height: LEGEND_SWATCH_TRACK_HEIGHT_PX
        }, "aria-hidden": true }, { children: _jsx("span", { className: "block w-full", style: {
                borderTop: "".concat(dashed ? "".concat(LEGEND_LINE_STROKE_PX, "px dashed") : "".concat(LEGEND_LINE_STROKE_PX, "px solid"), " ").concat(color)
            } }) })));
};
